(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.svSE = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = {
    el: {
      autocomplete: {
        noDataMessage: 'Inga data hittades'
      },
      combobox: {
        placeholder: 'Välj',
        searchPlaceholder: 'Sök'
      },
      datepicker: {
        apply: 'Tillämpa',
        clearSelection: 'Rensa',
        pickADays: 'Välj dagar',
        prevYear: 'Föregående år',
        nextYear: 'Nästa år',
        prevMonth: 'Föregående månad',
        nextMonth: 'Nästa månad',
        year: 'År',
        month1: 'Januari',
        month2: 'Februari',
        month3: 'Mars',
        month4: 'April',
        month5: 'Maj',
        month6: 'Juni',
        month7: 'Juli',
        month8: 'Augusti',
        month9: 'September',
        month10: 'Oktober',
        month11: 'November',
        month12: 'December',
        weeks: {
          sun: 'Sön',
          mon: 'Mån',
          tue: 'Tis',
          wed: 'Ons',
          thu: 'Tor',
          fri: 'Fre',
          sat: 'Lör'
        },
        months: {
          jan: 'Jan',
          feb: 'Feb',
          mar: 'Mar',
          apr: 'Apr',
          may: 'Maj',
          jun: 'Jun',
          jul: 'Jul',
          aug: 'Aug',
          sep: 'Sep',
          oct: 'Okt',
          nov: 'Nov',
          dec: 'Dec'
        },
        pickADay: 'Välj en dag'
      },
      timepicker: {
        meridiemAM: 'fm.',
        meridiemPM: 'em.'
      },
      dropdown: {
        noDataMessage: 'Inga data hittades'
      },
      filepicker: {
        browse: 'Bläddra',
        select: 'Välj en fil'
      },
      filter: {
        apply: 'Tillämpa',
        cancel: 'Avbryt',
        filterButton: 'Filter',
        reset: 'Återställ filter',
        resetDefault: 'Återställ till standard'
      },
      search: {
        noDataMessage: 'Inga data hittades'
      },
      'multi-search': {
        'separator-and': 'OCH',
        'search-button': 'Sök',
        'search-placeholder': 'Sök efter namn'
      },
      select: {
        all: 'Alla',
        clearSelection: 'Töm urval',
        noMatch: 'Inga data hittades',
        noData: 'Inga data',
        placeholder: 'Välj',
        item: 'objekt',
        selected: 'markerad',
        found: 'hittad'
      },
      upload: {
        browseButton: 'Bläddra',
        text: 'Dra och släpp filerna för att ladda upp, eller klicka på ”Bläddra”',
        tip: 'Du kan ladda upp 10 filer på upp till 25 MB vardera'
      },
      table: {
        emptyText: 'Inga data'
      },
      tree: {
        emptyText: 'Inga data'
      }
    }
  };
  _exports.default = _default;
});